var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "규제항목",
            merge: _vm.grid.merge,
            columns: _vm.grid.columns,
            data: _vm.chem.reguls,
            gridHeight: _vm.gridHeight,
            filtering: false,
            isExcelDown: false,
            isFullScreen: false,
            columnSetting: false,
            selection: "multiple",
            rowKey: "regulatedItemCd",
          },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: { label: "LBLADD", icon: "add" },
                        on: { btnClicked: _vm.addRegul },
                      })
                    : _vm._e(),
                  _vm.editable && _vm.chem.reguls.length > 0
                    ? _c("c-btn", {
                        attrs: { label: "LBLEXCEPT", icon: "delete" },
                        on: { btnClicked: _vm.deleteRegul },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }